export default {
  labelsLoaded: false,
  loading: 0,
  isMobileMenuToggled: false,
  queryParamError: false,
  spa: [],
  title: ''
}
